export const GET_ALL_ANALYTICS_REPORTS = "GET_ALL_ANALYTICS_REPORTS";
export const START_LOADING_ANALYTICS_REPORTS = "START_LOADING_ANALYTICS_REPORTS";
export const ERROR_LOADING_ANALYTICS_REPORTS = "ERROR_LOADING_ANALYTICS_REPORTS"
export const STOP_LOADING_ANALYTICS_REPORTS = "STOP_LOADING_ANALYTICS_REPORTS";
export const RESET_DATA = "RESET_DATA";
